module.exports = __webpack_public_path__ + "img/generali.8a211ad7.png";